module.exports = __webpack_public_path__ + "static/media/Screenshot_4.3ab90a21.png";